import React, { useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import HardPaywallCard from './hard-paywall-card';
import { SUBSCRIBER_FEATURES } from '../../../../constants';
import BenifitsCard from './benifits-card';

import './profit-subscription.m.css';

const ProfitSubscription = ({ independenceDay, churnUser, plans = [] }) => {
  const [isActive, setActive] = useState(true);

  return (
    <>
      <div
        styleName={`subscription-container ${independenceDay.active ? 'event-theme' : ''} `}
        id="subscription-home"
      >
        <img src="/images/web-bottom.svg" alt="web-bottom" styleName="web-bottom" />
        <div styleName={`shadow ${!isActive ? 'shadow-none' : ''}`} className="mobile-only"></div>
        <div styleName="card-section" className="container">
          <div styleName="feature-card" className="desktop-only">
            {SUBSCRIBER_FEATURES.filter((dl, index) => index % 2 === 0).map((list, idx) => (
              <div styleName="icon-title" key={list?.id + idx}>
                <img
                  src={list.link2}
                  styleName="sub-icon"
                  alt={list.title}
                  style={{ width: list.width, height: list.height }}
                />
                <div styleName="text-wrap">
                  <div styleName="sub-title">{list.title}</div>
                  {list.desc === 'Bloomberg' ? (
                    <div styleName="sub-desc bloomberg">
                      <img
                        src="/icons/Bloomberg_grey.svg"
                        alt={list.desc}
                        styleName="bloomberg-icon"
                      />
                      Stories
                    </div>
                  ) : (
                    <div styleName="sub-desc">{list.desc}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <HardPaywallCard churnUser={churnUser} plans={plans} />
          <div styleName="feature-card" className="desktop-only">
            {SUBSCRIBER_FEATURES.filter((dl, index) => index % 2 !== 0).map((list, idx) => (
              <div styleName="icon-title" key={list?.id + idx}>
                <img
                  src={list.link2}
                  styleName="sub-icon"
                  alt={list.title}
                  style={{ width: list.width, height: list.height }}
                />
                <div styleName="text-wrap">
                  <div styleName="sub-title">{list.title}</div>
                  {list.desc === 'Bloomberg' ? (
                    <div styleName="sub-desc bloomberg">
                      <img
                        src="/icons/Bloomberg_grey.svg"
                        alt={list.desc}
                        styleName="bloomberg-icon"
                      />
                      Stories
                    </div>
                  ) : (
                    <div styleName="sub-desc">{list.desc}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="mobile-only">
            <BenifitsCard setActive={setActive} isActive={isActive} />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  independenceDay: get(state, ['qt', 'config', 'features', 'independence_day'], false),
});

export default connect(mapStateToProps)(ProfitSubscription);
